import { combineReducers } from 'redux';

import { authReducer } from './reducer';

export const authModuleReducer = combineReducers({
  authReducer,
});

export type AuthModuleState = ReturnType<typeof authModuleReducer>;
